<template>
  <div class="container">
    <h1>コンタクト</h1>
    <h3>連絡先</h3>
    <a href="https://twitter.com/k_bigwheel">@k_bigwheel</a>に対してリプライもしくはダイレクトメッセージでお問い合わせください。
    <h3>注意</h3>
    <p>
    本サイトはいらすとや本家を運用されているみふねたかし氏に公認を頂いておりますがあくまでファンサイトです。<br/>
    <span class="text-danger">
      本サイトに関していらすとや本家様およびみふねたかし氏へ問い合わせることは迷惑になりますので絶対におやめください。
    </span>
    </p>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'コンタクト'
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Contact.vue